import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledDiv, StyledMessagesIcon, StyledT3 } from './NoResults.styles';
import { ReactComponent as EmailIcon } from '../../../../../assets/email.svg';

export interface NoResultsProps { }

const NoResults: FC<NoResultsProps> = () => {
  const { t } = useTranslation('SecureMessagingPage');

  return (
    <StyledDiv>
      <StyledMessagesIcon as={EmailIcon} />
      <StyledT3>{t('noMessages')}</StyledT3>
    </StyledDiv>
  );
};

export default NoResults;
